export const rulesData = [
  {
    id: 1,
    label: "Art. 1 - Partecipazione e requisiti",
    items: [
      {
        type: "text",
        value:
            "Possono partecipare alle competizioni ARENA tutti gli atleti tesserati presso società o associazioni riconosciute, in possesso di certificato medico agonistico valido."
      },
      {
        type: "text",
        value:
            "L’iscrizione agli eventi deve essere completata nei tempi e nelle modalità stabilite dall’organizzazione."
      },
      {
        type: "text",
        value:
            "Gli atleti devono presentarsi con documento d’identità, tesseramento e liberatoria firmata."
      },
      {
        type: "text",
        value:
            "L’organizzazione si riserva il diritto di escludere o sospendere un partecipante in caso di comportamenti contrari allo spirito sportivo o al presente regolamento."
      }
    ]
  },

  {
    id: 2,
    label: "Art. 2 – L’Arena di combattimento",
    items: [
      {
        type: "text",
        value:
            "Il combattimento si svolge all’interno dell’ARENA, spazio quadrato o ottagonale con pavimentazione in tatami professionale o superficie ammortizzata."
      },
      {
        type: "text",
        value:
            "Le dimensioni standard variano da 6x6 a 8x8 metri, con area di sicurezza di almeno 1 metro per lato."
      },
      {
        type: "text",
        value:
            "Il perimetro dell’Arena è delimitato visivamente da linee o strutture morbide, atte a garantire sicurezza e visibilità."
      },
      {
        type: "text",
        value:
            "Ogni Arena è dotata di illuminazione adeguata, cronometro visibile e postazioni per arbitri, medico e staff tecnico."
      }
    ]
  },

  {
    id: 3,
    label: "Art. 3 – Abbigliamento e protezioni",
    items: [
      {
        type: "text",
        value:
            "Gli atleti devono indossare l’uniforme ufficiale approvata dalla Promotion ARENA."
      },
      {
        type: "text",
        value:
            "Sono ammessi pantaloni da combattimento e rashguard o top tecnico."
      },
      {
        type: "text",
        value:
            "Non è consentito l’uso di capi metallici, accessori rigidi o gioielli."
      },
      {
        type: "text",
        value: "Protezioni obbligatorie:"
      },
      {
        type: "list",
        items: [
          "Guantoni omologati (7/8 oz per Light, 4 oz per Semi-Pro e Pro)",
          "Paradenti",
          "Conchiglia protettiva",
          "Paratibie e parapianta per Light",
          "Caschetto solo per categorie giovanili"
        ]
      }
    ]
  },

  {
    id: 4,
    label: "Art. 4 – Equipaggiamento tecnico dell’Arena",
    items: [
      {
        type: "text",
        value:
            "Ogni evento ARENA deve disporre di attrezzatura regolamentare conforme agli standard di sicurezza."
      },
      {
        type: "text",
        value: "L’Arena è dotata di:"
      },
      {
        type: "list",
        items: [
          "Tatami o superficie ammortizzata a incastro, spessore minimo 3 cm",
          "Cronometro ufficiale per la gestione dei round",
          "Sistema di punteggio digitale o cartaceo validato dal responsabile di gara",
          "Sedute per i coach, postazione medico-sanitaria, tavolo giuria e area di riscaldamento atleti"
        ]
      },
      {
        type: "text",
        value:
            "Eventuali arredi o elementi scenici non devono interferire con lo spazio di combattimento né rappresentare rischio di urto."
      }
    ]
  },

  {
    id: 5,
    label: "Art. 5 – Coach e accompagnatori",
    items: [
      {
        type: "text",
        value:
            "Ogni atleta può essere accompagnato da un coach principale e un assistente, entrambi registrati."
      },
      {
        type: "text",
        value:
            "I coach devono mantenere un comportamento rispettoso verso arbitri e avversari."
      },
      {
        type: "text",
        value:
            "Durante il combattimento possono fornire indicazioni verbali senza invadere l’Arena né toccare l’atleta."
      },
      {
        type: "text",
        value:
            "Solo tra i round è consentito l’intervento diretto per fornire acqua o sistemare le protezioni."
      },
      {
        type: "text",
        value:
            "Comportamenti scorretti, linguaggio offensivo o istruzioni contrarie alle regole possono comportare ammonizione o squalifica dell’atleta."
      }
    ]
  },

  {
    id: 6,
    label: "Art. 6 – Ufficiali di gara",
    items: [
      {
        type: "text",
        value: "Il regolare svolgimento degli incontri è garantito da:"
      },
      {
        type: "list",
        items: [
          "Arbitro centrale: dirige il combattimento, assegna penalità e controlla la sicurezza",
          "Giudici laterali (2 o 3): valutano i punti tecnici e segnalano penalità",
          "Cronometrista: gestisce tempi di round, pause e segnali acustici",
          "Medico di gara: verifica l’idoneità degli atleti e interviene in caso di infortunio",
          "Responsabile di tavolo: raccoglie i punteggi e convalida il risultato finale"
        ]
      },
      {
        type: "text",
        value:
            "Le decisioni arbitrali sono definitive, salvo errori tecnici evidenti valutati dal direttore di gara."
      }
    ]
  },

  {
    id: 7,
    label: "Art. 7 – Durata e struttura degli incontri",
    items: [
      {
        type: "text",
        value: "La durata dei round varia in base alla categoria:"
      },
      {
        type: "table",
        headers: ["Categoria", "Round", "Durata", "Pausa"],
        rows: [
          ["Cadetti A e B", "2", "1 min 30 sec", "30 sec"],
          ["Juniores", "2", "2 min 30 sec", "30 sec"],
          ["Seniores Light", "3", "2 min", "1 min"],
          ["Semi-Pro", "3", "2 min 30 sec", "1 min"],
          ["Pro", "3", "3 min", "1 min"]
        ]
      },
      {
        type: "text",
        value:
            "In caso di parità assoluta, può essere previsto un round supplementare (“extra round”) a discrezione della giuria."
      },
      {
        type: "text",
        value:
            "Il tempo di recupero per infortuni non deve superare 2 minuti, salvo diversa indicazione del medico."
      }
    ]
  },

  {
    id: 8,
    label: "Art. 8 – Tecniche ammesse",
    items: [
      {
        type: "text",
        value:
            "Sono consentite tutte le tecniche tradizionali del karate adattate al contatto pieno, nel rispetto delle categorie e della sicurezza."
      },
      {
        type: "text",
        value: "Le principali tecniche ammesse sono:"
      },
      {
        type: "list",
        items: [
          "Pugni diretti (jab, diretto, gancio, montante)",
          "Calci frontali, circolari, laterali e bassi",
          "Ginocchiate, secondo la categoria di appartenenza",
          "Proiezioni e sbilanciamenti controllati",
          "Ground & Pound controllato nei tempi e modalità previste"
        ]
      },
      {
        type: "text",
        value:
            "Il Ground & Pound (colpi da posizione a terra) è ammesso dai 16 anni in su, con colpi diretti ma non a martello."
      },
      {
        type: "text",
        value:
            "Non sono ammesse leve articolari, strangolamenti o manovre di sottomissione."
      }
    ]
  },

  {
    id: 9,
    label: "Art. 9 – Tecniche vietate",
    items: [
      {
        type: "text",
        value:
            "Sono vietate le azioni che mettono in pericolo l’incolumità dell’avversario o che violano lo spirito sportivo dell’Arena:"
      },
      {
        type: "list",
        items: [
          "Colpi alla nuca, alla colonna, ai genitali o agli occhi",
          "Testate, morsi o dita negli orifizi",
          "Proiezioni pericolose o cadute con impatto diretto sulla testa",
          "Ginocchiate al volto per categorie Light e Semi-Pro",
          "Colpi a martello in qualsiasi situazione",
          "Uso di sottomissioni o leve articolari",
          "Proseguire l’attacco dopo l’intervento dell’arbitro"
        ]
      },
      {
        type: "text",
        value:
            "Le violazioni possono comportare penalità, sottrazione di punti, squalifica immediata o sospensione disciplinare."
      }
    ]
  },

  {
    id: 10,
    label: "Art. 10 – Categorie di età e peso",
    items: [
      {
        type: "table",
        headers: ["Categoria", "Età", "Tipo gara", "Tecniche principali", "Limitazioni"],
        rows: [
          [
            "Cadetti A",
            "13–14 anni",
            "Light",
            "Colpi diretti + proiezioni leggere",
            "No ganci, montanti, ginocchiate, sottomissioni"
          ],
          [
            "Cadetti B",
            "15 anni",
            "Light",
            "Colpi diretti + proiezioni leggere",
            "No ganci, montanti, ginocchiate, sottomissioni"
          ],
          [
            "Juniores",
            "16–17 anni",
            "Light",
            "Tutte le tecniche + Ground & Pound",
            "No ginocchiate, sottomissioni"
          ],
          [
            "Seniores Light",
            "18+",
            "Light",
            "Tutte le tecniche + Ground & Pound",
            "No ginocchiate, sottomissioni"
          ],
          [
            "Seniores Semi-Pro",
            "18+",
            "Semi-Pro",
            "Tutte le tecniche + ginocchiate al corpo + Ground & Pound",
            "No ginocchiate al volto, no sottomissioni"
          ],
          [
            "Seniores Pro",
            "18+",
            "Pro",
            "Tutte le tecniche + ginocchiate al corpo + Ground & Pound",
            "No ginocchiate al volto, no sottomissioni"
          ]
        ]
      },
      {
        type: "text",
        value:
            "Le categorie di peso sono stabilite in base al sesso e alla divisione agonistica, secondo le fasce definite dalla Promotion ARENA e comunicate prima di ogni evento."
      }
    ]
  },

  {
    id: 11,
    label: "Art. 11 – Valutazione tecnica e punteggi",
    items: [
      {
        type: "text",
        value:
            "Ogni round viene valutato da due o tre giudici laterali."
      },
      {
        type: "text",
        value: "Il punteggio si basa su:"
      },
      {
        type: "list",
        items: [
          "Efficacia dei colpi puliti e controllati",
          "Combinazioni tecniche riuscite",
          "Proiezioni con controllo e continuità d’azione",
          "Dominio territoriale e iniziativa",
          "Difesa e capacità di risposta"
        ]
      },
      {
        type: "text",
        value:
            "Ogni round può essere assegnato 10–9 o 10–8 in caso di netta superiorità."
      },
      {
        type: "text",
        value:
            "Un atterramento senza conclusione vale come proiezione valida; il Ground & Pound controllato conferisce punteggio maggiore."
      }
    ]
  },

  {
    id: 12,
    label: "Art. 12 – Condotta e penalità",
    items: [
      {
        type: "text",
        value:
            "Gli atleti devono mantenere atteggiamento rispettoso in ogni momento."
      },
      {
        type: "text",
        value: "Sono previste le seguenti penalità:"
      },
      {
        type: "list",
        items: [
          "Ammonizione verbale (richiamo semplice)",
          "Avvertimento ufficiale (−1 punto)",
          "Squalifica in caso di infrazione grave o recidiva"
        ]
      },
      {
        type: "text",
        value:
            "La mancanza di rispetto verso arbitri, avversari o pubblico comporta immediata squalifica e possibile sospensione da eventi futuri."
      }
    ]
  },

  {
    id: 13,
    label: "Art. 13 – Interruzioni e decisioni mediche",
    items: [
      {
        type: "text",
        value:
            "L’arbitro può interrompere l’incontro in qualunque momento per motivi di sicurezza o per verificare lo stato di un atleta."
      },
      {
        type: "text",
        value:
            "Il medico di gara è l’unica figura abilitata a decretare l’impossibilità di proseguire a causa di infortunio."
      },
      {
        type: "text",
        value:
            "In caso di taglio, contusione o perdita momentanea dell’equilibrio, l’arbitro può concedere un tempo massimo di 2 minuti di recupero."
      },
      {
        type: "text",
        value:
            "Se l’atleta non è in grado di riprendere il combattimento entro il tempo stabilito, l’incontro viene assegnato all’avversario per TKO (Technical Knockout)."
      }
    ]
  },

  {
    id: 14,
    label: "Art. 14 – Modalità di vittoria",
    items: [
      {
        type: "text",
        value:
            "Un incontro ARENA può concludersi nelle seguenti modalità:"
      },
      {
        type: "list",
        items: [
          "Vittoria ai punti: al termine dei round, secondo la valutazione dei giudici",
          "TKO (Interruzione tecnica): per superiorità evidente o impossibilità dell’avversario a proseguire",
          "KO (Knockout): perdita di sensi o incapacità di rialzarsi entro 10 secondi",
          "Squalifica: per infrazioni gravi o comportamenti antisportivi",
          "Forfait: rinuncia dell’atleta o del coach prima o durante il match",
          "Decisione medica: su parere del medico di gara"
        ]
      },
      {
        type: "text",
        value:
            "In caso di parità assoluta, la giuria può deliberare un extra round o attribuire il pareggio ufficiale."
      }
    ]
  },

  {
    id: 15,
    label: "Art. 15 – Sicurezza e controlli pre-gara",
    items: [
      {
        type: "text",
        value:
            "Prima di ogni evento, gli atleti devono sottoporsi a controllo medico preliminare e verifica dell’equipaggiamento."
      },
      {
        type: "text",
        value:
            "Gli arbitri devono accertarsi che le protezioni siano integre, correttamente indossate e conformi agli standard ARENA."
      },
      {
        type: "text",
        value:
            "Eventuali alterazioni volontarie delle protezioni comportano squalifica immediata."
      },
      {
        type: "text",
        value:
            "La Promotion ARENA si riserva di eseguire controlli aggiuntivi sullo stato fisico e psicologico degli atleti."
      }
    ]
  },

  {
    id: 16,
    label: "Art. 16 – Antidoping e comportamento sportivo",
    items: [
      {
        type: "text",
        value:
            "Sono vietate sostanze o pratiche che alterino le prestazioni fisiche o mentali dell’atleta."
      },
      {
        type: "text",
        value:
            "La Promotion ARENA adotta i principi del codice WADA e può disporre test antidoping casuali o mirati."
      },
      {
        type: "text",
        value:
            "Ogni atleta trovato positivo sarà squalificato e soggetto a sospensione prolungata."
      },
      {
        type: "text",
        value:
            "L’uso di linguaggio offensivo, atteggiamenti provocatori o comportamenti contrari al rispetto marziale può comportare penalità fino all’espulsione dall’evento."
      }
    ]
  },

  {
    id: 17,
    label: "Art. 17 – Reclami e decisioni finali",
    items: [
      {
        type: "text",
        value:
            "Eventuali reclami tecnici devono essere presentati dal coach principale entro 30 minuti dalla conclusione dell’incontro, per iscritto e accompagnati da una cauzione."
      },
      {
        type: "text",
        value:
            "Il direttore di gara esamina la segnalazione e comunica la decisione entro 24 ore."
      },
      {
        type: "text",
        value:
            "Le decisioni del direttore di gara e della Promotion ARENA sono inappellabili."
      },
      {
        type: "text",
        value:
            "Eventuali revisioni video sono a discrezione dell’organizzazione."
      }
    ]
  },

  {
    id: 18,
    label: "Art. 18 – Disposizioni generali",
    items: [
      {
        type: "text",
        value:
            "La Promotion ARENA si riserva il diritto di modificare, aggiornare o integrare il presente regolamento in base all’evoluzione tecnica e alle esigenze organizzative."
      },
      {
        type: "text",
        value:
            "Ogni variazione entra in vigore al momento della sua pubblicazione ufficiale."
      },
      {
        type: "text",
        value:
            "La partecipazione agli eventi implica l’accettazione integrale di tutte le norme contenute in questo documento."
      },
      {
        type: "text",
        value:
            "Il rispetto del regolamento e dello spirito ARENA è ciò che distingue il combattente tecnico dal semplice lottatore: nell’Arena si combatte per onore, non solo per vittoria."
      }
    ]
  }
];